<panel width="600">
	<h1>{{ 'sale.order-cancellation.canceled-due-to' | translate }}</h1>
	<section>
		<reason-select [label]="'sale.order-cancellation.reasonlist-label' | translate" [(reasonId)]="selectedReasonId" [type]="reasonType.OrderCancellation" [required]="true" />
		<textarea [(ngModel)]="comment" [placeholder]="'sale.order-cancellation.further-info' | translate"></textarea>
	</section>
	<section>
		<button confirm (click)="createOrderCancellation()">{{ 'general.save' | translate }}</button>
	</section>
</panel>
